<template>
    <div class="ui-page">
        <ui-page-header title="Casos" subtitle="Recuperações judiciais e falências acompanhadas pelo escritório.">
            <v-btn v-if="$allowed('create')" id="btnNew" type="button" color="primary" depressed to="/casos/novo">
                <v-icon left small>mdi-plus</v-icon>
                Incluir
            </v-btn>
        </ui-page-header>

        <ui-table-card clearable :can-clear="hasFilters" @clear="clearFilters">
            <template #toolbar>
                <v-text-field dense placeholder="Buscar pelo nome" v-model="dataList.filter.name" hide-details outlined
                    prepend-inner-icon="mdi-magnify" class="ui-toolbar__search" @input="filterDebounced"
                    @keyup.enter="applyFilters"></v-text-field>
                <v-text-field dense placeholder="Processo" v-model="dataList.filter.process_number" hide-details outlined
                    class="ui-toolbar__field" @input="filterDebounced" @keyup.enter="applyFilters"></v-text-field>
                <v-text-field dense placeholder="Vara" v-model="dataList.filter.local" hide-details outlined
                    class="ui-toolbar__field" @input="filterDebounced" @keyup.enter="applyFilters"></v-text-field>
                <v-select no-data-text="Nenhuma comarca encontrada" dense :items="dataset.districts"
                    placeholder="Todas as comarcas" v-model="dataList.filter.district" item-value="id" item-text="name"
                    outlined hide-details class="ui-toolbar__field" :menu-props="{ offsetY: true }" @change="applyFilters">
                </v-select>
            </template>

            <v-data-table :headers="dataList.headers" :items="dataList.data"
                :server-items-length="dataList.count" disable-sort hide-default-footer :loading="dataList.loading"
                no-data-text="Nenhum caso foi encontrado" loading-text="Carregando dados..."
                :options.sync="dataList.options" class="ui-clickable-rows" @click:row="openRow">

                <template v-slot:[`item.name`]="{ item }">
                    <div class="ui-cell-main">{{ item.name }}</div>
                    <div v-if="item.companies && item.companies.length" class="ui-cell-sub">
                        Grupo: {{ item.companies.map(company => company.name).join(', ') }}
                    </div>
                </template>

                <template v-slot:[`item.created_at`]="{ item }">
                    {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm") }}
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                    <ui-row-actions :actions="[
                        { text: 'Editar', icon: 'mdi-pencil-outline', disabled: !$check('Client', 'PATCH'), handler: () => viewItem(item) },
                        { text: 'Excluir', icon: 'mdi-delete-outline', danger: true, disabled: !$check('Client', 'DELETE'), handler: () => deleteItem(item) },
                    ]" />
                </template>
            </v-data-table>

            <template #footer>
                <ui-pagination :total="dataList.count" :page="dataList.options.page" :items-per-page="dataList.options.size"
                    :disabled="dataList.loading" @update:page="pageChanged" @update:itemsPerPage="setPageSize" />
            </template>
        </ui-table-card>
    </div>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"
import eventStatus from "@/common/data/event-status.data";

Vue.use(VueLodash)

export default {
    name: "UserList",

    data: () => ({
        dataset: {
            eventStatus: [{ id: "", name: "Todos" }, ...eventStatus],
            districts: [{ id: "", name: "Todos" }],
            eventTypes: [{ id: "", name: "Todos" }, { id: 1, name: "Habilitação" }, { id: 2, name: "Divergência" }],
            data: {}
        },
        dataList: {
            filter: {
                name: "",
                status: "",
                type: "",
                district: ""
            },
            headers: [
                { text: "Nome", value: "name" },
                { text: "Processo", value: "process_number" },
                { text: "Vara", value: "local" },
                { text: "Comarca", value: "district.name" },
                { text: "Criado em", value: "created_at" },
                { text: '', value: 'actions', sortable: false, align: 'end', width: 56 },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                size: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            },
           
        },
    }),

    computed: {
        hasFilters() {
            return Object.values(this.dataList.filter).some((value) => value);
        },
    },

    created() {
        this.load();
        this.loadDistricts();
    },

    methods: {
        applyFilters() {
            this.dataList.options.page = 1;
            this.load();
        },

        filterDebounced: _.debounce(function () {
            this.applyFilters();
        }, 400),

        clearFilters() {
            this.dataList.filter = { name: "", status: "", type: "", district: "" };
            this.applyFilters();
        },

        // A troca de tamanho e seguida de update:page(1), que recarrega.
        setPageSize(size) {
            this.dataList.options.size = size;
        },

        // clientPageText() {
        //     return `${this.dataList.paging.page} de ${this.dataList.paging.pages}`;
        // },

        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.size = size;
            this.load(true);
        },

        getColorByStatus(status) {
            switch (status) {
                case 0:
                    return 'warning'
                case 1:
                    return 'accent'
                case 2:
                    return 'error'
                default:
                    break;
            }
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },

        async load() {

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            var limit = this.dataList.options.size;

            try {
                const result = await axios.get('/api/clients', { params: { page: this.dataList.options.page, limit: limit, search: search } });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        async loadDistricts() {

            try {
                const result = await axios.get(`/api/districts`, { params: { start: 1, limit: 100000, search: {} } });

                this.dataset.districts = [{ id: "", name: "Todos" }, ...result.data.content.data];

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        // A linha abre o detalhe so com a mesma permissao do "Editar".
        openRow(item) {
            if (this.$check('Client', 'GET')) this.viewItem(item);
        },

        viewItem(item) {
            this.$router.push(`casos/${item.id}`);
        },

        async deleteItem(item) {

            if (!item || !item.id) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Excluir Caso',
                actions: {
                    false: 'Cancelar',
                    true: 'Excluir'
                }
            })

            if (!proceedAction) return;
            
            this.dataList.loading = true

            try {

                const result = await axios.delete(`/api/admin/clients/${item.id}`)

                this.$dialog.notify.info("Caso excluído com sucesso", { position: "top-right", timeout: 2000 });

                this.load()

            } catch (error) {

                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })

            } finally {
                this.dataList.loading = false;
            }

        },
    },
};
</script>
